import { NgModule } from '@angular/core';
import { Ng2SmartTableModule } from 'ng2-smart-table';

import { SharedModule } from '../../shared/shared.module';
import { DashboardComponent } from './dashboard.component';
import { DashboardWellsComponent } from './dashboard-wells/dashboard-wells.component';
import { DashboardService } from './dashboard.service';
import { HistoricalWellsService } from '../manage/historical-wells/historical-wells.service';
import { DashboardPadComponent } from './dashboard-pad/dashboard-pad.component';

@NgModule({
  declarations: [DashboardComponent, DashboardWellsComponent, DashboardPadComponent],
  imports: [
    Ng2SmartTableModule,
    SharedModule
  ],
  providers: [
    DashboardService,
    HistoricalWellsService,
  ]
})
export class DashboardModule { }
